import React from 'react'
import PropTypes from 'prop-types'
import { StyledCSSTransition } from './styled'
import ContentPresenter from '../ContentPresenter'

const CarouselSlide = ({ content, setContentTime, ...rest }) => {
  // NodeRef needed to avoid deprecated warning:
  // https://github.com/reactjs/react-transition-group/blob/8dc9ad8d9412878a40312e418d389bf97f3794b8/CHANGELOG.md#440-2020-05-05
  const nodeRef = React.useRef(null)

  return (
    <StyledCSSTransition nodeRef={nodeRef} classNames='content-transition' {...rest}>
      <div ref={nodeRef}>
        <ContentPresenter content={content} contentType={content.contentType} setContentTime={setContentTime} />
      </div>
    </StyledCSSTransition>
  )
}

CarouselSlide.defaultProps = {
  content: {},
  timeout: 0,
}

CarouselSlide.propTypes = {
  content: PropTypes.object,
  timeout: PropTypes.number,
  setContentTime: PropTypes.func,
}

export default CarouselSlide
